import type { GameListItemDto } from '@/queries/games/games.schema';

import GameCard from '@/components/entities/games/GameCard';
import GameSkeleton from '@/components/entities/games/GameCard/components/GameSkeleton';
import { AppRoutes } from '@/i18n/constants';
import { cn } from '@/utils/cn';

interface Props {
  isLoading: boolean;
  filteredGames: GameListItemDto[];
}

export default function ListOfGames({ isLoading, filteredGames }: Props) {
  return (
    <>
      <div className="grid grid-cols-3 md:grid-cols-4  gap-1.75  md:gap-5 mb-6.5">
        {isLoading
          ? Array.from({ length: 3 }).map((_, index) => (
              <GameSkeleton key={index} className={cn('p-0', isLoading && 'mb-4.25')} />
            ))
          : filteredGames.map(game => (
              <GameCard
                likeButtonPosition="compact"
                likeButtonIconSize="compactLg"
                id={game.id}
                key={game.id}
                className="p-0"
                name={game.name}
                cover={game.cover}
                path={AppRoutes.gamesId(game.id)}
              />
            ))}
      </div>
    </>
  );
}
